import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-3',
  templateUrl: './3.component.html',
  styleUrls: ['./3.component.scss'],
})
export class VbList3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
